<template>
  <cs-view wide-nav>
    <template v-slot:left-content>
      <slot-indicator slot-name="Page Left Content" width="100%" height="100%">
        <template v-slot:content>
          <v-container>
            <v-col cols="10">
              <v-card>
                <div class="justify-center pt-2">Home Page</div>
                <v-row class="ml-3 mb-2">
                  <a :href="`${geminiUrl}`">Gemini</a>
                </v-row>
                <v-row class="ml-3 mb-2">
                  <a :href="`${apolloUrl}`">Apollo</a>
                </v-row>
                <v-row class="ml-3 mb-2">
                  <a :href="`${artemisUrl}`">Artemis</a>
                </v-row>
              </v-card>

              <v-card>
                <div class="justify-center pt-2">Login Page</div>
                <v-row class="ml-3 mb-2">
                  <a :href="`${geminiUrl}/login`">Gemini</a>
                </v-row>
                <v-row class="ml-3 mb-2">
                  <a :href="`${apolloUrl}/login`">Apollo</a>
                </v-row>
                <v-row class="ml-3 mb-2">
                  <a :href="`${artemisUrl}/login`">Artemis</a>
                </v-row>
              </v-card>

              <v-card>
                <div class="justify-center pt-2">Wide Navigation Page</div>
                <v-row class="ml-3 mb-2">
                  <a :href="`${geminiUrl}/wide-nav`">Gemini</a>
                </v-row>
                <v-row class="ml-3 mb-2">
                  <a :href="`${apolloUrl}/wide-nav`">Apollo</a>
                </v-row>
                <v-row class="ml-3 mb-2">
                  <a :href="`${artemisUrl}/wide-nav`">Artemis</a>
                </v-row>
              </v-card>
            </v-col>
          </v-container>
        </template>
      </slot-indicator>
    </template>

    <template v-slot:right-content>
      <slot-indicator slot-name="Page Right Content" width="100%" height="100%">
        <template v-slot:content>
          <v-container>
            <v-row>
              <v-col>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="onSetLoading"> Set Loading </v-btn>
                </v-row>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="onClearLoading"> Clear Loading </v-btn>
                </v-row>
              </v-col>
              <v-col>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="fullscreenDialog = true">
                    Open Fullscreen Dialog
                  </v-btn>
                </v-row>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="textTitleDialog = true">
                    Open Text Title Dialog
                  </v-btn>
                </v-row>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="headerDialog = true"> Open Header Dialog </v-btn>
                </v-row>
              </v-col>
              <v-col>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="onShowErrorAlert"> Show Error Alert </v-btn>
                </v-row>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="onShowSuccessAlert"> Show Success Alert </v-btn>
                </v-row>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="onShowInfoAlert"> Show Info Alert </v-btn>
                </v-row>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="onShowWarningAlert"> Show Warning Alert </v-btn>
                </v-row>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="onClearAlert"> Clear Alert </v-btn>
                </v-row>
              </v-col>
              <v-col>
                <v-row class="ma-3">
                  <v-text-field v-model="snackBarText"> </v-text-field>
                </v-row>
                <v-row class="ma-3">
                  <v-btn width="100%" @click="onSetSnackBarText"> Set SnackBar Text </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </slot-indicator>
      <cs-dialog
        v-model="fullscreenDialog"
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
      >
        <template v-slot:fullscreen-dialog-header>
          <v-btn icon dark @click="fullscreenDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn width="100%" dark text @click="fullscreenDialog = false"> Save </v-btn>
          </v-toolbar-items>
        </template>
        <template v-slot:fullscreen-dialog-body>
          <v-list three-line subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>List item Title 1</v-list-item-title>
                <v-list-item-subtitle> List item Subtitle 1 </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>List item Title 2</v-list-item-title>
                <v-list-item-subtitle> List item Subtitle 2 </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list three-line subheader>
            <v-subheader>Checkbox Demo</v-subheader>
            <v-list-item>
              <v-list-item-action>
                <v-checkbox v-model="checkbox1"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Checkbox 1</v-list-item-title>
                <v-list-item-subtitle> Checkbox 1 description </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-checkbox v-model="checkbox2"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Checkbox 2</v-list-item-title>
                <v-list-item-subtitle> Checkbox 2 description </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-checkbox v-model="checkbox3"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Checkbox 3</v-list-item-title>
                <v-list-item-subtitle> Checkbox 3 description </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-subheader>Show alerts</v-subheader>
          <v-list-item>
            <v-row>
              <v-col>
                <v-btn width="100%" @click="onShowErrorDialogAlert">Show Error Alert</v-btn>
              </v-col>
              <v-col>
                <v-btn width="100%" @click="onShowSuccessDialogAlert">Show Success Alert</v-btn>
              </v-col>
              <v-col>
                <v-btn width="100%" @click="onShowInfoDialogAlert">Show Info Alert</v-btn>
              </v-col>
              <v-col>
                <v-btn width="100%" @click="onShowWarningDialogAlert">Show Warning Alert</v-btn>
              </v-col>
              <v-col>
                <v-btn width="100%" @click="onClearAlert">Clear Alert</v-btn>
              </v-col>
            </v-row>
          </v-list-item>
          <v-divider></v-divider>
          <v-row>
            <p>
              {{ testText }}
            </p>
          </v-row>
        </template>
      </cs-dialog>
      <cs-dialog
        v-model="textTitleDialog"
        transition="dialog-bottom-transition"
        scrollable
        max-width="600px"
      >
        <template v-slot:dialog-title>
          <span>Dialog Title</span>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="textTitleDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </template>
        <template v-slot:dialog-body-text>
          <p>This is dialog title, uses v-card-title.</p>
          <p>{{ testText }}</p>
        </template>
        <v-spacer></v-spacer>
        <template v-slot:dialog-actions>
          <v-btn @click="onShowErrorDialogAlert">Show Error Alert</v-btn>
          <v-btn @click="onShowSuccessDialogAlert">Show Success Alert</v-btn>
          <v-btn color="green darken-1" text @click="textTitleDialog = false"> Disagree </v-btn>
          <v-btn color="green darken-1" text @click="onAgree"> Agree </v-btn>
        </template>
      </cs-dialog>
      <cs-dialog
        v-model="headerDialog"
        transition="dialog-bottom-transition"
        scrollable
        max-width="600px"
      >
        <template v-slot:dialog-header>
          <span>Dialog Header</span>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="headerDialog = false" color="white">
            <v-icon>close</v-icon>
          </v-btn>
        </template>
        <template v-slot:dialog-body-text>
          <p>This is dialog header, uses v-toolbar as header.</p>
          <p>{{ testText }}</p>
        </template>
        <v-spacer></v-spacer>
        <template v-slot:dialog-actions>
          <v-btn @click="onShowErrorDialogAlert">Show Error Alert</v-btn>
          <v-btn @click="onShowSuccessDialogAlert">Show Success Alert</v-btn>
          <v-btn color="green darken-1" text @click="headerDialog = false"> Disagree </v-btn>
          <v-btn color="green darken-1" text @click="onAgree"> Agree </v-btn>
        </template>
      </cs-dialog>
    </template>
  </cs-view>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import { mapMutations } from 'vuex';
import SlotIndicator from '../components/SlotIndicator';
import * as types from '../store/mutationTypes';

export default {
  name: 'Home',

  components: { SlotIndicator },

  extends: CSBase,

  data() {
    return {
      geminiUrl: process.env.VUE_APP_GEMINI_URL,
      apolloUrl: process.env.VUE_APP_APOLLO_URL,
      artemisUrl: process.env.VUE_APP_ARTEMIS_URL,
      fullscreenDialog: false,
      textTitleDialog: false,
      headerDialog: false,
      snackBarText: '',
      checkbox1: false,
      checkbox2: false,
      checkbox3: true,
      tokenText: '',
      decodedTokenText: '',
      userText: '',
      tokenLoading: false,
      userLoading: false,
      logoutLoading: false,
      testText:
        'This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. '
    };
  },

  async mounted() {
    this.setPageViewType('wide-nav');
  },

  methods: {
    ...mapMutations({
      setPageViewType: types.VIEW_TYPE_SET_PAGE_VIEW_TYPE
    }),

    onSetLoading() {
      this.setLoading(true);
    },

    onClearLoading() {
      this.clearLoading();
    },

    onShowErrorAlert() {
      this.showErrorAlert('This is an error alert.');
    },

    onShowSuccessAlert() {
      this.showSuccessAlert('This is an success alert.');
    },

    onShowInfoAlert() {
      this.showInfoAlert('This is an info alert.');
    },

    onShowWarningAlert() {
      this.showWarningAlert('This is an warning alert.');
    },

    onShowErrorDialogAlert() {
      this.showErrorAlert(
        'This configuration will prevent users from logging in via Ideagen Home’s authentication solution. Make sure all fields below are filled in correctly in order to prevent any login issues.',
        true
      );
    },

    onShowSuccessDialogAlert() {
      this.showSuccessAlert('This is an success alert.', true);
    },

    onShowInfoDialogAlert() {
      this.showInfoAlert('This is an info alert.', true);
    },

    onShowWarningDialogAlert() {
      this.showWarningAlert('This is an warning alert.', true);
    },

    onClearAlert() {
      this.clearAlert();
    },

    onAgree() {
      this.textTitleDialog = false;
      this.headerDialog = false;
      this.showSuccessAlert('Agreed');
    },

    onSetSnackBarText() {
      this.showSnackBar(this.snackBarText);
    }
  }
};
</script>

<style scoped></style>
